module.exports = __webpack_public_path__ + "img/WenTop.3259e822.jpg";